import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";

import { LinkButton, NormalButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { InfoItem, ShariahItem } from "components/pf";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";
import Benefits from "components/benefits";
import Icon from "assets/images/line_icons.svg";
import PropertyEligibility from "components/eligibility/PropertyEligibility";
import FeesAndCharges from "components/fee&charges/FeesAndCharges";

import Financing from "assets/images/hero-images/Banner_Financing.png";
import BG from "assets/images/hero-images/BG.png";

function PropertyFinancingHome() {
  const pfBenefitsData = [
    {
      title: (
        <>
          <b>Competitive Financing Rate</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">
          Financing Rate as low as <b>3.9%* p.a.</b> (*Terms & Conditions Apply).{" "}
        </p>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <b>Financing</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">Margin of financing up to 90%.</p>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <b>Tenure</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">Tenures of up to 35 years.</p>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <b>Takaful Coverage</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">
          Comprehensive Takaful coverage provided.{" "}
        </p>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <b>Available Package</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">
          Zero entry cost package available.{" "}
        </p>
      ),
      delay: "300",
    },
  ];
  const pfBenefitsConfig = {
    heading: "Benefits",
    tnc: "*Terms & Conditions apply",
    // faq: "FAQ",
    benefitsData: pfBenefitsData,
    desktopImages: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    mobileImage: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    tncLink: "/tnc",
  };

  const pfEligibility = {
    type: "pf",
    title: "Apply easily",
    steps: 1,
    highlightedText: "in just 1 step",
    documentsTitle: "Required Documents",
    employeeType: "Salaried employees",
    yearsOld: "years old",
    documents: [
      {
        title: "<span>Salaried employees</span>",
        content: "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>3 months salary slip</b> and <b>bank statement showing salary credited</b></li><li>Latest <b>EPF statement</b></li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li><li><b>Property Title</b></li></ul>",
        backgroundColor: "#DCE9FF",
      },
      {
        title: "<span>Self-employed</span>",
        content: "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>6 months bank statement</b></li><li><b>Business Registration Document</b></li><li>Copy of <b>Income Tax</b> & proof of tax payment</li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li><li><b>Property Title</b></li></ul>",
        backgroundColor: "#F2F4F7",
      },
    ],
  };
  
  const pfFeesAndCharges = {
    type: "pf",
    title: "Fees & Charges",
    documents: [
      {
        title: "Retrieval / Photocopy of Security Documents",
        content: "Actual Cost",
      },
      {
        title: "EPF Withdrawal Confirmation Letter Fee",
        content: "RM10.00 per request",
      },
      {
        title: "Annual Financing Statement Fee",
        content: "RM 5.00 per request (Ad-hoc)",
      },
      {
        title: "Redemption Statement Fee",
        content: "RM 10.00 per request",
      },
      {
        title: "Brokerage Fee",
        content: "0.0008% of the principal amount of financing/disbursement",
      },
      {
        title: "ARNT Fee (or Agency Fee)",
        content: "RM 1.00 per transaction",
      },
    ],
    buttons: [
      {
        title: "Product Disclosure Sheet",
        link: `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS-HomeFinancing.pdf`,
      },
      {
        title: "Download Application Form",
        link: `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf`,
      },
    ]
  };

  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Home
              </span>      
               Financing-<em>i</em>
             `}
          buttonText="Let's connect! "
          backgroundImage={Financing}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row pf-page" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3 className="general-header">About</h3>
          </div>
          <div className="col-xl-8">
            <p className="about-text">
              alrajhi bank Malaysia Home Financing-<em>i</em> assist you to own
              your dream home with peace of mind.
            </p>
            <p className="about-text">
              Looking to buy your dream home or refinance your existing
              property? Enjoy attractive rate from as low as <b>3.9%* p.a.</b>{" "}
              with our easy, stress-free Home financing-<em>i </em>
              packages. (*Terms and conditions apply)
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Competitive Financing Rate
                </div>
                <div className="column-subheader-2">
                  Financing Rate as low as <b>3.9%* p.a.</b> (*Terms &
                  Conditions Apply){" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Financing</div>
                <div className="column-subheader-2">
                  Margin of financing up to 90%{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Tenure</div>
                <div className="column-subheader-2">
                  Tenures of up to 35 years{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Takaful Coverage</div>
                <div className="column-subheader-2">
                  Comprehensive Takaful coverage provided{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Available Package</div>
                <div className="column-subheader-2">
                  Zero entry cost package available
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Need More Info?</div>
                <div className="column-subheader-2">
                  <NormalButton
                    text="Read our FAQs"
                    onClick={() =>{
                      if (faqRef.current) {
                        const offset = 156; // Adjust this value as needed
                        const topPosition = faqRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({
                          top: topPosition,
                          behavior: 'smooth'
                        });
                      }
                    }}
                    style={{ fontSize: "14px", margin: "10px 0 20px" }}
                  />
                  <Link className="link_benefits d-block no-wrap" to={"/tnc"}>
                    *Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Benefits {...pfBenefitsConfig} />

      <section className="section about container">
        <ShariahItem
          header={<span>Shariah Contract</span>}
          subheader="Commodity Murabahah (via Tawarruq arrangement)"
          Icon={Icon}
        />
        {/* <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Shariah Contract</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Requirements</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Salaried Employees: </div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 3 months <b>latest 3 months salary slip</b> and{" "}
                    <b>bank statement showing salary credited</b>
                  </li>
                  <li>
                    Latest <b>EPF statement</b>
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
              <div className="col-xl-5 col-12 custom-column">
                <div className="column-header-2">Self-employed:</div>
                <div className="column-subheader pt-3">
                  <li>
                    Photocopy of <b>IC / Identification document</b>
                  </li>
                  <li>
                    Latest 6 months <b>bank statement</b>
                  </li>
                  <li>
                    <b>Business registration Form</b>
                  </li>
                  <li>
                    Copy of <b>Income Tax</b> & proof of tax payment
                  </li>
                  <li>
                    Sales & <b>Purchase Agreement</b> / Booking receipt
                    <li>
                      <b>Property Title</b>
                    </li>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <PropertyEligibility {...pfEligibility} />

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <InfoItem
                header="Retrieval / Photocopy of Security Documents"
                subheader="Actual Cost"
              />
              <InfoItem
                header="EPF Withdrawal Confirmation Letter Fee"
                subheader="RM10.00 per request"
              />

              <InfoItem
                header="Annual Financing Statement Fee"
                subheader="RM 5.00 per request (Ad-hoc)"
              />
              <InfoItem
                header="Redemption Statement Fee"
                subheader="RM 10.00 per request"
              />
              <InfoItem
                header="Brokerage Fee"
                subheader="0.0008% of the principal amount of financing/disbursement"
              />
              <InfoItem
                header="ARNT Fee (or Agency Fee)"
                subheader="RM 1.00 per transaction"
              />
            </div>
            <div className="link-button-row pt-5">
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS-HomeFinancing.pdf`)}
              />
              <LinkButton
                text="Download Application Form"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf `
                  )
                }
              />
            </div>
          </div>
        </div>
      </section> */}
      <FeesAndCharges {...pfFeesAndCharges} />

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4 mb-3">
            <h3>Frequently Asked Questions</h3>
          </div>
          <div className="col-xl-8">
            <AccordionSimple data={FaqListPFHome} />
          </div>
        </div>
      </section> */}

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4 d-xl-block d-none">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <MainFooter />
      <SubFooter /> */}
    </div>
  );
}

export default PropertyFinancingHome;
